import React, {useState, useEffect, useRef} from 'react';
import {useGoogleReCaptcha} from 'react-google-recaptcha-v3';
import {useContextSelector} from 'use-context-selector';
import {Modal, Button, Alert, Form} from 'react-bootstrap';
import ModalRef from '../util/ModalRef';
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons/faChevronLeft'
import {faPaperPlane} from '@fortawesome/free-solid-svg-icons/faPaperPlane'
import {useTranslation} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {LocalContext} from '../context/LocalContext';
import {useBreakpoint} from '../util/handleBreakpoints';
import useOnFieldChange from '../util/useOnFieldChange';
import FieldContainer from '../common/FieldContainer';
import useSubmitProvidersContactRequest from './useSubmitProvidersContactRequest';
import useCreateClientStatusMessage from '../util/useCreateClientStatusMessage';

const ProvidersCheckoutContact = (props) => {
    const {t} = useTranslation();
    const breakpoints = useBreakpoint();

    const submitProvidersContactRequest = useSubmitProvidersContactRequest();
    const createClientStatusMessage = useCreateClientStatusMessage();

    const {executeRecaptcha} = useGoogleReCaptcha();

    const isMounted = useRef(null);

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        }
    }, []);

    const clientOnline = useContextSelector(LocalContext, v => v[0].clientOnline);

    const fieldsContactProvidersInitial = {
        valid: false,
        fields: {
            name: {
                value: '',
                validate: true,
                rules: [
                    {
                        type: 'notEmpty'
                    },
                    {
                        type: 'minLength',
                        length: 5
                    }
                ],
                required: true,
                valid: false,
                touched: false,
                errors: [],
                errorsFragment: []
            },
            organization: {
                value: '',
                validate: true,
                rules: [
                    {
                        type: 'validOnEmpty'
                    }
                ],
                required: false,
                valid: true,
                touched: false,
                errors: [],
                errorsFragment: []
            },
            phone: {
                value: '',
                validate: true,
                rules: [
                    {
                        type: 'isNumeric'
                    },
                    {
                        type: 'validOnEmpty'
                    },
                    {
                        type: 'maxLength',
                        length: 64
                    }
                ],
                required: false,
                valid: true,
                touched: false,
                errors: [],
                errorsFragment: []
            },
            email: {
                value: '',
                validate: true,
                rules: [
                    {
                        type: 'notEmpty'
                    },
                    {
                        type: 'isEmail'
                    }
                ],
                required: true,
                valid: false,
                touched: false,
                errors: [],
                errorsFragment: []
            },
            messageBody: {
                value: '',
                validate: true,
                rules: [
                    {
                        type: 'notEmpty'
                    },
                    {
                        type: 'maxLength',
                        length: 384
                    },
                    {
                        type: 'minLength',
                        length: 10
                    }
                ],
                required: true,
                valid: false,
                touched: false,
                errors: [],
                errorsFragment: []
            },
        }
    }

    const [fieldsContactProviders, setFieldsContactProviders] = useState({...fieldsContactProvidersInitial});

    const onFieldContactProvidersChange = useOnFieldChange(fieldsContactProviders, setFieldsContactProviders);

    const onShow = () => {
    }

    const onHide = () => {
        props.setModeContactProviders(false);
        if (!props.providerEntrySingle) {
            props.setModeProvidersCheckout(false);
        }
    }

    const [isLoadingSubmitProvidersContact, setIsLoadingSubmitProvidersContact] = useState(false);
    // const [isErrorSubmitProvidersContact, setIsErrorSubmitProvidersContact] = useState(false);
    const setIsErrorSubmitProvidersContact = useState(false)[1];

    const handleProvidersCheckoutContact = async () => {
        setIsLoadingSubmitProvidersContact(true);
        let recaptchaToken
        try {
            recaptchaToken = await executeRecaptcha();
        } catch (error) {
            console.log(error);
            setIsLoadingSubmitProvidersContact(false);
            setIsErrorSubmitProvidersContact(true);
            props.setProvidersContactedMessage(
                <Alert
                    variant="danger"
                    dismissible
                    onClose={
                        () => props.setProvidersContactedMessageSeen(true)
                    }
                    className="mb-0 rounded-0"
                >
                    <p>{t('ProviderContactRequest.message-error-recaptcha')}</p>
                </Alert>)
            props.setProvidersContactedError(true);
            props.setModeContactProviders(false);
            return
        }

        console.log(recaptchaToken);

        // let response;
        try {
            await submitProvidersContactRequest(fieldsContactProviders.fields, props.filters, props.providersSelected, props.spawnedFrom, recaptchaToken);
        } catch (error) {
            if (isMounted.current) {
                setIsLoadingSubmitProvidersContact(false);
                setIsErrorSubmitProvidersContact(true);
                createClientStatusMessage(error.clientStatusMessage);
            }
            return
        }

        // console.log(response);

        if (isMounted.current) {
            props.providerEntrySingle ?
                props.setProvidersContactedMessage(
                    <>
                        <Alert
                            variant="success"
                            onClose={
                                () => props.setProvidersContactedMessageSeen(true)
                            }
                            className="mb-0"
                        >
                            <p><strong>{t('Providers.ProvidersCheckoutContact.message-sent-success-single.p1')}</strong> {t('Providers.ProvidersCheckoutContact.message-sent-success-single.p2')}<em>{props.providersSelected[0].title}</em>{t('Providers.ProvidersCheckoutContact.message-sent-success-single.p3')}</p>
                            <p className="mb-0">{t('Providers.ProvidersCheckoutContact.message-sent-success-single.p4')} <em>{fieldsContactProviders.fields.email.value}</em> {t('Providers.ProvidersCheckoutContact.message-sent-success-single.p5')}</p>
                        </Alert>
                    </>
                ) :
                props.setProvidersContactedMessage(
                    <Alert
                        variant="success"
                        dismissible
                        onClose={
                            () => props.setProvidersContactedMessageSeen(true)
                        }
                        className="mb-0 rounded-0"
                    >
                        <p><strong>{t('Providers.ProvidersCheckoutContact.message-sent-success.p1')}</strong> {t('Providers.ProvidersCheckoutContact.message-sent-success.p2')} {t('Providers.ProvidersCheckoutContact.message-sent-success.p3')}</p>
                        <p className="mb-0">{t('Providers.ProvidersCheckoutContact.message-sent-success.p4')} <em>{fieldsContactProviders.fields.email.value}</em> {t('Providers.ProvidersCheckoutContact.message-sent-success.p5')}</p>
                    </Alert>
                )
            props.setProvidersContacted(true);
            props.setModeContactProviders(false);
        }
    }

    return <>
        <style>
            {
                (breakpoints.md || breakpoints.sm) && !breakpoints.xs ?
                    `
                        .modal-dialog {
                            max-width: calc(100% - 4rem);
                        }
                    ` : `
                        .modal-dialog {
                            max-width: 60rem;
                                
                        }
                    `
            }
        </style>
        <Modal
            container={ModalRef}
            show={true}
            size="lg"
            backdrop="static"
            onHide={onHide}
            onShow={onShow}
            keyboard={false}
            animation={false}
            key="modalProvidersCheckoutContact"
            onEntered={
                () => {
                    document.querySelector("#contact-providers-email").focus();
                }
            }
        >
            <Form>
                <Modal.Header
                    closeButton={!isLoadingSubmitProvidersContact}
                    className="bg-light"
                >
                    {
                        props.providerEntrySingle ?
                            <span
                                style={
                                    {
                                        fontWeight: 500
                                    }
                                }
                            >
                                {t('Providers.ProvidersCheckoutContact.contacting-provider-x')}{props.providersSelected[0].title}
                            </span> :
                            <span
                                style={
                                    {
                                        fontWeight: 500
                                    }
                                }
                            >{t('Providers.ProvidersCheckoutContact.contact-selected-providers')}</span>
                    }
                </ Modal.Header>
                <div
                    style={
                        {
                            overflow: 'hidden',
                            padding: '0.75rem',
                            paddingBottom: '1.25rem',
                            paddingTop: '1.75rem'
                        }
                    }
                >
                    <div
                        style={
                            {
                            }
                        }
                    >
                        <div
                            style={
                                {
                                    display: 'flex',
                                    flexWrap: 'wrap'
                                }
                            }
                        >
                            <div
                                style={
                                    {
                                        padding: '0 1.25rem',
                                    }
                                }
                            >
                                <h5 className="mb-0">{t('Providers.ProvidersCheckoutContact.fields-about-you')}</h5>
                            </div>
                            <div
                                style={
                                    {
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        width: '100%'
                                    }
                                }
                            >
                                <div
                                    style={
                                        {
                                            overflow: 'hidden',
                                            flexBasis: '23rem',
                                            flexGrow: 1,
                                            flexShrink: 1,
                                            padding: '0 1.25rem',
                                        }
                                    }
                                >
                                    <FieldContainer
                                        dense={true}
                                        wrap={true}
                                        label={
                                            <Form.Label htmlFor="contact-providers-name">{t('Providers.ProvidersCheckoutContact.name')}{fieldsContactProviders.fields.name.required && <span className="form-field-container__required-field-indicator">*</span>}</Form.Label>
                                        }
                                        control={
                                            <>
                                                <Form.Control
                                                    // placeholder={t('Providers.ProvidersCheckoutContact.name')}
                                                    id="contact-providers-name"
                                                    isValid={fieldsContactProviders.fields.name.valid && fieldsContactProviders.fields.name.touched}
                                                    isInvalid={!fieldsContactProviders.fields.name.valid && fieldsContactProviders.fields.name.touched}
                                                    value={fieldsContactProviders.fields.name.value}
                                                    onChange={(event) => {
                                                        onFieldContactProvidersChange(event.target.value, 'name');
                                                    }}
                                                />
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                >
                                                    <div>{fieldsContactProviders.fields.name.errorsFragment}</div>
                                                </Form.Control.Feedback>
                                            </>
                                        }
                                    />
                                </div>

                                <div
                                    style={
                                        {
                                            overflow: 'hidden',
                                            flexBasis: '23rem',
                                            flexGrow: 1,
                                            flexShrink: 1,
                                            padding: '0 1.25rem',
                                        }
                                    }
                                >
                                    <FieldContainer
                                        dense={true}
                                        wrap={true}
                                        label={
                                            <Form.Label htmlFor="contact-providers-organization">{t('Providers.ProvidersCheckoutContact.organization')}{fieldsContactProviders.fields.organization.required && <span className="form-field-container__required-field-indicator">*</span>}</Form.Label>
                                        }
                                        control={
                                            <>
                                                <Form.Control
                                                    id="contact-providers-organization"
                                                    // placeholder={t('Providers.ProvidersCheckoutContact.organization')}
                                                    isValid={fieldsContactProviders.fields.organization.valid && fieldsContactProviders.fields.organization.touched}
                                                    isInvalid={!fieldsContactProviders.fields.organization.valid && fieldsContactProviders.fields.organization.touched}
                                                    value={fieldsContactProviders.fields.organization.value}
                                                    onChange={(event) => {
                                                        onFieldContactProvidersChange(event.target.value, 'organization');
                                                    }}
                                                />
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                >
                                                    <div>{fieldsContactProviders.fields.organization.errorsFragment}</div>
                                                </Form.Control.Feedback>
                                            </>
                                        }
                                    />

                                </div>

                                <div
                                    style={
                                        {
                                            overflow: 'hidden',
                                            flexBasis: '23rem',
                                            flexGrow: 1,
                                            flexShrink: 1,
                                            padding: '0 1.25rem',
                                        }
                                    }
                                >
                                    <FieldContainer
                                        dense={true}
                                        wrap={true}
                                        label={
                                            <Form.Label htmlFor="contact-providers-email">{t('Providers.ProvidersCheckoutContact.email-address')}{fieldsContactProviders.fields.email.required && <span className="form-field-container__required-field-indicator">*</span>}</Form.Label>
                                        }
                                        control={
                                            <>
                                                <Form.Control
                                                    id="contact-providers-email"
                                                    // placeholder={t('Providers.ProvidersCheckoutContact.email-address')}
                                                    isValid={fieldsContactProviders.fields.email.valid && fieldsContactProviders.fields.email.touched}
                                                    isInvalid={!fieldsContactProviders.fields.email.valid && fieldsContactProviders.fields.email.touched}
                                                    value={fieldsContactProviders.fields.email.value}
                                                    onChange={(event) => {
                                                        onFieldContactProvidersChange(event.target.value, 'email');
                                                    }}
                                                />
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                >
                                                    <div>{fieldsContactProviders.fields.email.errorsFragment}</div>
                                                </Form.Control.Feedback>
                                            </>
                                        }
                                    />
                                </div>
                                <div
                                    style={
                                        {
                                            overflow: 'hidden',
                                            flexBasis: '23rem',
                                            flexGrow: 1,
                                            flexShrink: 1,
                                            padding: '0 1.25rem',
                                        }
                                    }
                                >
                                    <FieldContainer
                                        dense={true}
                                        wrap={true}
                                        label={
                                            <Form.Label htmlFor="contact-providers-phone">{t('Providers.ProvidersCheckoutContact.phone')}{fieldsContactProviders.fields.phone.required && <span className="form-field-container__required-field-indicator">*</span>}</Form.Label>
                                        }
                                        control={
                                            <>
                                                <Form.Control
                                                    id="contact-providers-phone"
                                                    // placeholder={t('Providers.ProvidersCheckoutContact.phone')}
                                                    isValid={fieldsContactProviders.fields.phone.valid && fieldsContactProviders.fields.phone.touched}
                                                    isInvalid={!fieldsContactProviders.fields.phone.valid && fieldsContactProviders.fields.phone.touched}
                                                    value={fieldsContactProviders.fields.phone.value}
                                                    onChange={(event) => {
                                                        onFieldContactProvidersChange(event.target.value, 'phone');
                                                    }}
                                                />
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                >
                                                    <div>{fieldsContactProviders.fields.phone.errorsFragment}</div>
                                                </Form.Control.Feedback>
                                            </>
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            style={
                                {
                                    padding: '1.25rem 1.25rem 0 1.25rem',
                                }
                            }
                        >
                            <h5>{props.providerEntrySingle ? `${t('Providers.ProvidersCheckoutContact.fields-inquiry-provider-x')}${props.providersSelected[0].title}` : t('Providers.ProvidersCheckoutContact.fields-inquiry')}</h5>
                            <div>
                                <FieldContainer
                                    wrap={true}
                                    dense={true}
                                    label={
                                        <Form.Label htmlFor="contact-providers-message-body">{t('Providers.ProvidersCheckoutContact.message-body')} <span className="text-muted">({fieldsContactProviders.fields.messageBody.value.length} / {fieldsContactProviders.fields.messageBody.rules.find(rule => rule.type === 'maxLength').length})</span>{fieldsContactProviders.fields.messageBody.required && <span className="form-field-container__required-field-indicator">*</span>}</Form.Label>
                                    }
                                    control={
                                        <>
                                            <Form.Control
                                                id="contact-providers-message-body"
                                                // placeholder={t('Providers.ProvidersCheckoutContact.message-body')}
                                                as="textarea"
                                                rows="7"
                                                isValid={fieldsContactProviders.fields.messageBody.valid && fieldsContactProviders.fields.messageBody.touched}
                                                isInvalid={!fieldsContactProviders.fields.messageBody.valid && fieldsContactProviders.fields.messageBody.touched}
                                                value={fieldsContactProviders.fields.messageBody.value}
                                                onChange={(event) => {
                                                    onFieldContactProvidersChange(event.target.value, 'messageBody');
                                                }}
                                            />
                                            <Form.Control.Feedback
                                                type="invalid"
                                            >
                                                <div>{fieldsContactProviders.fields.messageBody.errorsFragment}</div>
                                            </Form.Control.Feedback>
                                        </>
                                    }
                                />
                            </div>
                        </div>

                        <p
                            style={
                                {
                                    fontSize: '0.85rem',
                                    padding: '1.25rem 1.25rem',
                                }
                            }
                        ><span className="form-field-container__required-field-indicator">*</span>{t('Providers.ProvidersCheckoutContact.tip-required-fields')}</p>
                        <p
                            style={
                                {
                                    fontSize: '0.85rem',
                                    padding: '0 1.25rem',
                                }
                            }
                        >{t('message-conditions-recaptcha.p1')}<a rel="noopener noreferrer" target="_blank" href="https://policies.google.com/privacy">{t('message-conditions-recaptcha.p2')}</a>{t('message-conditions-recaptcha.p3')}<a rel="noopener noreferrer" target="_blank" href="https://policies.google.com/terms">{t('message-conditions-recaptcha.p4')}</a> {t('message-conditions-recaptcha.p5')}</p>
                    </div>
                </div>
                <Modal.Footer
                    className="bg-light"
                >
                    <Button
                        variant="dark"
                        className={breakpoints.xs ? "btn-block" : "mr-auto"}
                        onClick={
                            () => {
                                props.setModeContactProviders(false);
                            }
                        }
                    >
                        {
                            props.providerEntrySingle ?
                                <span>{t('Providers.ProvidersCheckoutContact.close')}</span> :
                                <>
                                    <span><FontAwesomeIcon icon={faChevronLeft} /></span><span className="ml-2">{t('Providers.ProvidersCheckoutContact.back-to-selected-list')}</span>
                                </>
                        }
                    </Button>
                    <Button
                        variant={"primary"}
                        className={breakpoints.xs ? "btn-block" : null}
                        disabled={!clientOnline || !fieldsContactProviders.valid}
                        type="submit"
                        onClick={
                            (event) => {
                                event.preventDefault();
                                handleProvidersCheckoutContact();
                            }
                        }
                    >
                        <FontAwesomeIcon icon={faPaperPlane} /> {t('Providers.ProvidersCheckoutContact.send-message')}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal></>
}

export default ProvidersCheckoutContact;
